import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { ServiceLocator } from '../../../modules/abstract.module';
import { Subscription } from 'rxjs';
import { Interface } from 'readline';
import { Directive, OnDestroy } from '@angular/core';

@Directive()
export abstract class BbAbstractMenuComponent implements OnDestroy {
	activeLink: string;

	protected router: Router;
	protected subscriptions = new Subscription();

	constructor(private links: string[]) {
		this.router = ServiceLocator.injector.get(Router);
		this.getActiveLink();

		this.subscriptions.add(this.router.events.subscribe((routerEvent: RouterEvent) => {
			if (routerEvent instanceof NavigationEnd) {
				this.getActiveLink();
			}
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	private getActiveLink() {
		this.activeLink = '';
		for (const link in this.links) {
			if (this.router.url.indexOf('/' + this.links[link]) > -1) {
				this.activeLink = this.links[link];
				break;
			}
		}
	}
}
